import { Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';

@Component({
  selector: 'app-tenant-settings',
  templateUrl: './tenant-settings.component.html',
  styleUrls: ['./tenant-settings.component.scss']
})
export class TenantSettingsComponent implements OnInit {

  constructor(private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
